<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Daftar Tangki LN2" >
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody>
                    <tr class="row_data">
                      <td><b>Tarikh Pendaftaran</b></td>
                      <td><b>:</b></td>
                      <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>No. Tangki</b></td>
                      <td><b>:</b></td>
                      <td>{{data.no_tangki}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Model Tangki</b></td>
                      <td><b>:</b></td>
                      <td>{{data.lkp_model_tangki}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>No. Daftar Asset</b></td>
                      <td><b>:</b></td>
                      <td>{{data.no_daftar_aset}}</td>
                    </tr>
                  </tbody>
                  </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <table >
                  <tbody>
                    <tr class="row_data">
                      <td><b>Kapasiti Tangki (L)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.kapasiti}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Bil. Canister</b></td>
                      <td><b>:</b></td>
                      <td>{{data.bil_canister}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Tarikh Perolehan</b></td>
                      <td><b>:</b></td>
                      <td>{{ $zutil.dateformat(data.tarikh_perolehan)}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Nilai Perolehan (RM)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.nilai_perolehan}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'tangki.daftar',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Tangki LN2', route: '/tangki' },
        { label: 'Daftar Tangki LN2', route: '/tangki/daftar' },
        { label: 'Papar', route: '/tangki/daftar/'+this.id },
      ],
      data : {id : 0},
      
      tabs: [
      		  { title: 'Tangki Daftar', content: '' },
          ]
    }
  },
  methods: {

    getData()
    {
      this.$zcomm.get(this.api_service + 'tangki_daftar/show/'+this.id, {}).then(res => {
        this.data = res
        
        // this.listTabs()
      })

    },

   
   tutup(){
         this.$inertia.visit(window.route('tangki.daftar.index'));
       },
   
   

   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
